export default function normalizeItem(item) {
  return {
    id: item.id,
    code: item.code || '',
  }
}
